import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OperatingMonth } from '../models/operating-month.model';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperatingMonthService {

  private apiUrl = `${environment.sgcApi}`;
  private operatingMonthUrl = 'operatingMonth';

  constructor(
    private httpClient: HttpClient
  ) { }

  getOperatingMonth(): Observable<OperatingMonth> {
    let endpoint = `${this.apiUrl}${this.operatingMonthUrl}`;
    return this.httpClient.get<OperatingMonth>(endpoint)
      .pipe(map((data) => data));
  }
}
